import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { PageHeader } from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { taskState } from '../recoil/state/task'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { idTask } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { Name } = useRecoilValue(taskState)

  const statusEditLabel = idTask
    ? intl.formatMessage({ id: 'Load.NavMenu.Edit' })
    : intl.formatMessage({ id: 'Load.NavMenu.Create' })
  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__tasks',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({
        id: 'Load.MailupCommon.TaskPluralUppercase'
      }),
      'data-mu-test': 'breadcrumb-item__automation-tasks',
      className: 'test-breadcrumb-item__automation-tasks',
      url: '#',
      onClick: () => history.push('/automation/tasks/list')
    },
    {
      label: statusEditLabel,
      'data-mu-test': `breadcrumb-item__task-${statusEditLabel}`,
      className: `test-breadcrumb-item__task-${statusEditLabel}`
    }
  ]

  useEffect(() => {
    if (idTask) {
      notifyParent('selectMenuItemReact', ['UpdateTask', redirectUrl])
    } else {
      notifyParent('selectMenuItemReact', ['CreateTask', redirectUrl])
    }
  }, [redirectUrl, idTask])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={
        idTask
          ? Name
          : intl.formatMessage({
              id: 'Load.AutomationWorkflow.AutomationUntitled'
            })
      }
      loading={idTask ? !Name : false}
    />
  )
}

export default Header
